/**
 * Formats a field path into a human-readable name for error messages
 * Converts camelCase, snake_case, and path segments to Title Case
 * @param path - Dot-notation field path (e.g., "product.brandName")
 * @returns Formatted field name (e.g., "Brand Name")
 */
export const formatFieldNameForError = (path: string): string => {
  const parts = path.split('.');
  const lastPart = parts[parts.length - 1];
  
  const formatted = lastPart
    .replace(/_/g, ' ')
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .trim();
    
  return formatted
    .split(/\s+/)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

